import { render, staticRenderFns } from "./StorageList.vue?vue&type=template&id=6020b862"
import script from "./StorageList.vue?vue&type=script&lang=js"
export * from "./StorageList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports